import {EventEmitter, Injectable} from '@angular/core';
import {ServiceBase} from './service-base';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import {HttpClient, HttpHeaders} from '@angular/common/http';

@Injectable()
export class IppaymentService extends ServiceBase {

  paymentformIsInit: EventEmitter<any>;
  doCheckoutSession: EventEmitter<void> = new EventEmitter();

  constructor(private http: HttpClient) {
    super();
    this.paymentformIsInit = new EventEmitter<any>();
    this.doCheckoutSession = new EventEmitter<void>();
  }

  private static get checkoutIpPaymentSessionUrl(): string {
    return ServiceBase.baseHref + '/api/checkoutIpPaymentSession';
  }

  public static get checkPaymentStatusUrl(): string {
    return ServiceBase.baseHref + '/api/checkPaymentStatus';
  }

  checkoutIpPaymentSession(custRef: string, custNumber: string, amount: string, token: string): Observable<any> {
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);

    return this.http.post(IppaymentService.checkoutIpPaymentSessionUrl, JSON.stringify({
      custRef: custRef,
      custNumber: custNumber,
      amount: amount
    }), {headers: header});
  }

  checkPaymentStatus(sst: string, sessionId: string, token: string): Observable<any> {
    const header: HttpHeaders = new HttpHeaders()
    .append('Content-Type', 'application/json')
    .append('Authorization', 'Bearer ' + token);

    return this.http.post(IppaymentService.checkPaymentStatusUrl, JSON.stringify({
      sst: sst,
      sessionId: sessionId
    }), {headers: header});
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/ippayment.service.ts